import React, { useEffect } from 'react'

import { Box, Button, Grid } from '@material-ui/core'
import { FormContext, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'

import {
  ContractStep,
  EvaluationStep,
  GeneralInfoStep,
  RisksStep,
  Stepper,
} from 'views/ThirdPartyManagements/components'
import { OverviewStep } from '../../components'
import { DriveTour } from 'components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import { routes } from 'Routes'
import constants from 'constants/index'
import helpers from 'helpers'
import theme from 'theme'

const ShowForm = ({ fileList, openTour, setOpenTour }) => {
  const {
    isPreAvaliation,
    handleAdvanceStep,
    handleBack,
    handleReturnStep,
    wantsToReturnStep,
    companySupplier,
    activeStep,
  } = useThirdPartyManagementStepper()
  const history = useHistory()

  const { STEPS_OBJECT } = constants.tours.thirdPartyManagements
  const tourStepsMap = isPreAvaliation
    ? [
        STEPS_OBJECT.PRE_AVALIATION.SHOW.OVERVIEW,
        STEPS_OBJECT.PRE_AVALIATION.CREATION.GENERAL_INFO,
        STEPS_OBJECT.PRE_AVALIATION.SHOW.EVALUATION,
        STEPS_OBJECT.PRE_AVALIATION.CREATION.RISKS,
      ]
    : [
        STEPS_OBJECT.SHOW.OVERVIEW,
        STEPS_OBJECT.CREATION.GENERAL_INFO,
        STEPS_OBJECT.SHOW.EVALUATION,
        STEPS_OBJECT.CREATION.CONTRACT,
        STEPS_OBJECT.CREATION.RISKS,
      ]

  const supplier = companySupplier?.supplier || {}
  const companySupplierDetail = companySupplier?.companySupplierDetail || {}

  const defaultDocument = () => {
    const document = supplier?.document
    if (!document) return ''
    if (supplier?.international) return document
    return helpers.formatters.document.identify(document)
  }

  const formMethods = useForm({
    defaultValues: {
      name: companySupplier?.displayName || '',
      document: defaultDocument(),
      international: supplier?.international || false,
      segmentId: companySupplierDetail?.segment || null,
      description: companySupplierDetail?.description || '',
      newResponsibleEmail: '',
      endDate: companySupplier?.endDate || null,
      dateToSendEmails: companySupplier?.dateToSendEmails || null,
      hireDate: companySupplierDetail?.hireDate || null,
      renewDate: companySupplierDetail?.renewDate || null,
      treatmentAgentType:
        companySupplierDetail?.treatmentAgentType?.toLowerCase() || '',
      companyAgentType:
        companySupplierDetail?.companyAgentType?.toLowerCase() || '',
      attachments: fileList || [],
      riskLevel:
        helpers.thirdPartyManegementPartners.getRiskLevelByEnum(
          companySupplierDetail?.riskLevel,
        ) ?? 0,
      observation: companySupplierDetail?.observation || '',
      simplifiedRegister: companySupplier?.simplifiedRegister || false,
      hasInternationalTransfer:
        companySupplierDetail?.hasInternationalTransfer || false,
      internationalTransferDescription:
        companySupplierDetail?.internationalTransferDescription || '',
      internationalTransfers:
        companySupplierDetail?.internationalTransfers || [],
      suboperators: companySupplierDetail?.suboperators || [],
      responsibleEmails:
        companySupplier?.companySupplierUsers?.map(
          (companySupplierUser) => companySupplierUser?.user?.email,
        ) || [],
      selectedQuestionnaires:
        companySupplier?.companySupplierQuestionnaires?.map(
          (companySupplierQuestionnaire) =>
            companySupplierQuestionnaire?.questionnaire?.quizTemplateId,
        ) || [],
    },
  })

  const stepComponents = isPreAvaliation
    ? [<OverviewStep />, <GeneralInfoStep />, <EvaluationStep />, <RisksStep />]
    : [
        <OverviewStep />,
        <GeneralInfoStep />,
        <EvaluationStep />,
        <ContractStep />,
        <RisksStep />,
      ]

  const isLastStep = activeStep === stepComponents.length - 1

  const actionButtonText = () => (isLastStep ? 'Finalizar' : 'Avançar')

  const handleRedirect = () =>
    history.push(
      isPreAvaliation
        ? routes.thirdPartyManagements.preAvaliations
        : routes.thirdPartyManagements.mySuppliers.all,
    )

  useEffect(() => {
    if (wantsToReturnStep) handleBack()
  }, [wantsToReturnStep])

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stepper />
        </Grid>

        <Grid item xs={12}>
          <FormContext {...formMethods}>
            {stepComponents[activeStep]}
          </FormContext>
        </Grid>

        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="flex-end"
            gridGap={theme.spacing(2)}
          >
            <Button variant="outlined" onClick={handleReturnStep}>
              Voltar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={isLastStep ? handleRedirect : handleAdvanceStep}
            >
              {actionButtonText()}
            </Button>
          </Box>
        </Grid>
      </Grid>

      <DriveTour
        stepsMatrix={tourStepsMap[activeStep]}
        open={openTour}
        setOpen={setOpenTour}
      />
    </>
  )
}

export default ShowForm
